// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-vendor-container {
  min-height: 100vh;
  background: #f4f6f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.vendor-card {
  background: #ffffff;
  width: 700px;
  padding: 24px;
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(0,0,0,0.08);
}

.vendor-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.vendor-card-header h2 {
  margin: 0;
   font-size: 25px;
   text-align: center;
}

.subtitle {
  font-size: 13px;
  color: #6b7280;
}

.btn-back {
  background: none;
  border: none;
  color: #399994;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.vendor-form .form-group {
  margin-bottom: 16px;
}

.vendor-form label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  display: block;
}

.input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  /* padding: 10px 12px; */
  background: #fff;
}

.input-icon {
  color: #6b7280;
  margin-right: 8px;
}

.input-wrapper input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
}

.has-error .input-wrapper {
  border-color: #ef4444;
}

.error-text {
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.form-actions {
  margin-top: 24px;
}

.btn-save {
  width: 100%;
  background: #3aa38e;
  color: #fff;
  border: none;
  padding: 12px;
  border-radius: 10px;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-save:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.form-loader {
  padding: 40px;
  text-align: center;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Material/CreateVendor.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;GACR,eAAe;GACf,kBAAkB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".create-vendor-container {\n  min-height: 100vh;\n  background: #f4f6f9;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.vendor-card {\n  background: #ffffff;\n  width: 700px;\n  padding: 24px;\n  border-radius: 14px;\n  box-shadow: 0 12px 30px rgba(0,0,0,0.08);\n}\n\n.vendor-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.vendor-card-header h2 {\n  margin: 0;\n   font-size: 25px;\n   text-align: center;\n}\n\n.subtitle {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.btn-back {\n  background: none;\n  border: none;\n  color: #399994;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.vendor-form .form-group {\n  margin-bottom: 16px;\n}\n\n.vendor-form label {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 6px;\n  display: block;\n}\n\n.input-wrapper {\n  display: flex;\n  align-items: center;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  /* padding: 10px 12px; */\n  background: #fff;\n}\n\n.input-icon {\n  color: #6b7280;\n  margin-right: 8px;\n}\n\n.input-wrapper input {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 14px;\n}\n\n.has-error .input-wrapper {\n  border-color: #ef4444;\n}\n\n.error-text {\n  color: #ef4444;\n  font-size: 12px;\n  margin-top: 4px;\n  display: block;\n}\n\n.form-actions {\n  margin-top: 24px;\n}\n\n.btn-save {\n  width: 100%;\n  background: #3aa38e;\n  color: #fff;\n  border: none;\n  padding: 12px;\n  border-radius: 10px;\n  font-size: 15px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn-save:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n.form-loader {\n  padding: 40px;\n  text-align: center;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
